import type {Grant} from 'src/openapi/admin/models/Grant';
import type {Relation} from 'src/openapi/admin/models/Relation';
import type {Role} from 'src/openapi/admin/models/Role';

type PresetSuggestion = {
    id: string,
    name: string,
    grant?: Grant,
    relations: Relation[],
};

type Props = {
    relations: Relation[],
    roles: Record<string, Role>,
    grants: Record<string, Grant>,
    maxResults: number,
};

export const mapRelationsToSuggestions = ({relations, roles, grants, maxResults}: Props) => {
    const sections = [];

    const rolesSuggestions: PresetSuggestion[] = [];
    const freeGrantsSuggestions: PresetSuggestion[] = [];

    relations.forEach(relation => {
        if (relation.roleId) {
            const existedRoleSuggestion = rolesSuggestions.find(({id}) => id === relation.roleId);
            if (existedRoleSuggestion) {
                if (existedRoleSuggestion.relations.length < maxResults) {
                    existedRoleSuggestion.relations.push(relation);
                }
            } else {
                rolesSuggestions.push({
                    id: relation.roleId,
                    name: roles[relation.roleId].name,
                    relations: [relation],
                });
            }
        } else {
            const {grantId} = relation;
            const existedGrantSuggestion = freeGrantsSuggestions.find(({id}) => id === relation.grantId);
            if (existedGrantSuggestion) {
                if (existedGrantSuggestion.relations.length < maxResults) {
                    existedGrantSuggestion.relations.push(relation);
                }
            } else {
                freeGrantsSuggestions.push({
                    id: grantId,
                    name: grants[grantId].name,
                    grant: grants[grantId],
                    relations: [relation],
                });
            }
        }
    });

    if (rolesSuggestions.length > 0) {
        sections.push({
            title: 'Roles',
            suggestionItems: rolesSuggestions,
        });
    }

    if (freeGrantsSuggestions.length > 0) {
        sections.push({
            title: 'Free Grants',
            suggestionItems: freeGrantsSuggestions,
        });
    }

    return sections;
};

export const mapSelectedRelations = (relations: Relation[]) => {
    const ids: string[] = [];

    relations.forEach(relation => {
        if (relation.roleId) {
            const existedRoleSuggestion = ids.find(id => id === relation.roleId);
            if (!existedRoleSuggestion) {
                ids.push(relation.roleId);
            }
        } else {
            const existedGrantSuggestion = ids.find(id => id === relation.grantId);
            if (!existedGrantSuggestion) {
                ids.push(relation.grantId);
            }
        }
    });

    return ids;
};
